import * as apiDelete from 'api/mailAccount/DeleteMailAccountIdV1';
import * as apiRestore from 'api/mailAccount/PostMailAccountRestoreV1';
import * as apiPostSearch from 'api/mailAccount/PostMailAccountSearchV1';

export default class MailAccount {
	public id: string = '';
	public senderEmail: string = '';

	public constructor(input?: apiPostSearch.ResponseMailAccount) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseMailAccount) {
		this.id = input.id;
		this.senderEmail = input.senderEmail;
	}
}
